import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import AdminOverlay from "./users/AdminOverlay";
import AdminTabNav from "./components/AdminTabNav";
import UsersScreen from "./screens/UsersScreen";
import DepartmentsScreen from "./screens/DepartmentsScreen";
import RiskAssessmentScreen from "./screens/RiskAssessmentScreen";
import { ADMIN_TABS } from "./adminTabConfig";
import {
  getUsers,
  createUser,
  updateUser,
  resetEditUserOverlay,
  resetAdminError,
} from "../../store/actions/adminActions";

function AdminPage(props) {
  const {
    token,
    users,
    getUsersFN,
    createUserFN,
    updateUserFN,
    resetEditUserOverlayFN,
    edit_user_overlay,
    error_message,
    resetAdminErrorFN,
    created,
    departments,
  } = props;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editinguser, setEditingUser] = useState(null);
  const [currPage, setcurrPage] = useState("users");

  const openpopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    resetAdminErrorFN();
    getUsersFN();
    setIsPopupOpen(false);
    setEditingUser(null);
  };

  useEffect(() => {
    resetAdminErrorFN();
    getUsersFN();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (edit_user_overlay) {
      resetEditUserOverlayFN();
      setEditingUser(edit_user_overlay);
      openpopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit_user_overlay]);

  const tabNav = (
    <AdminTabNav tabs={ADMIN_TABS} activeKey={currPage} onSelect={setcurrPage} />
  );

  return token ? (
    <div className="flex flex-col w-full h-screen overflow-hidden">
      <TopBar className="fixed top-0 left-0 right-0 z-10" />
      <div className="flex flex-row w-full h-full overflow-hidden">
        <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" />
        <div className="flex flex-col w-full p-4 overflow-auto">
          {currPage === "users" && (
            <>
              {tabNav}
              <UsersScreen users={users} openpopup={openpopup} />
            </>
          )}

          {currPage === "levels" && (
            <>
              {tabNav}
              <RiskAssessmentScreen />
            </>
          )}

          {currPage === "departments" && (
            <>
              {tabNav}
              <div className="mt-4">
              <DepartmentsScreen />
              </div>
            </>
          )}
        </div>
      </div>

      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        modal
        nested
        closeOnDocumentClick={false}
        contentStyle={{
          padding: 0,
          border: "none",
          background: "transparent",
          boxShadow: "none",
          width: "auto",
          maxWidth: "none",
          overflow: "visible",
          marginTop: "14vh",
        }}
        overlayStyle={{
          background: "rgba(0,0,0,0)",
        }}
        className="no-popup-wrapper"
      >
        <AdminOverlay
          departments={departments}
          created={created}
          resetAdminErrorFN={resetAdminErrorFN}
          error_message={error_message}
          closePopup={closePopup}
          mode={editinguser ? "edit" : "create"}
          user={users && editinguser ? users.find((u) => u.user_id === editinguser) : null}
          doit={editinguser ? updateUserFN : createUserFN}
        />
      </Popup>
    </div>
  ) : (
    <Redirect to="/login" />
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
  users: state.admin.admin_users,
  edit_user_overlay: state.admin.edit_user_overlay,
  error_message: state.admin.error_message,
  created: state.admin.created,
  departments: state.department.departments,
});

const mapDispatchToProps = (dispatch) => ({
  getUsersFN: () => dispatch(getUsers()),
  createUserFN: (user) => dispatch(createUser(user)),
  updateUserFN: (user) => dispatch(updateUser(user)),
  resetEditUserOverlayFN: () => dispatch(resetEditUserOverlay()),
  resetAdminErrorFN: () => dispatch(resetAdminError()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(AdminPage);
